import constants from '../constants.json'

export default defineAppConfig({
    WWW_HOST: process.env.NODE_ENV === 'development' ? 'http://localhost' : 'https://foldwrap.com',
    API_HOST: process.env.NODE_ENV === 'development' ? 'http://localhost/api/v1' : 'https://foldwrap.com/api/v1',
    RUN_MODE: process.env.NODE_ENV,
    sitename: 'Foldwrap',
    rootTitle: constants.website.title,
    rootDescription: constants.website.description,

    editor_examples: constants.website.editor_examples,

    // lemonsqueezy: {
    //   testmode: false,
    //   product: {
    //     name: 'Foldwrap Pro subscription',
    //     link_testmode: 'https://foldwrap.lemonsqueezy.com/buy/a82c0896-dd2a-4d7a-b881-1bbf30675ef8',
    //     link_live: 'https://foldwrap.lemonsqueezy.com/buy/1eba7d51-f621-4663-92fc-613a8f50b42c',
    //   },
    // },

    plans: constants.plans,
    feature_flags: constants.feature_flags,
    ttx: constants.ttx,
    tips_editor: constants.tips_editor,

    cloudflare_turnstile_captcha_site_key: '0x4AAAAAAA4nGJQYQjp0D790', // used in captha on markdown-slides publish pages

    structdata: {
        // to use on JSON-LD as Person
        ress: {
            '@type': 'Person',
            name: 'Alex Antipov',
            sameAs: ['https://x.com/ress', 'https://linkedin.com/in/alexantipov', 'https://github.com/r-ss'],
        },
    },
})
